import { TClientTokenCard } from "../helpers/initialClientTokenCard";
import { postBlock } from "../service/postBlock";

type IValuesForm = {
    nameOnCard: string,
    cardNumber: string,
    cardValidity: string,
    cvv: string
}

export const postCardToken = async<T> (
    values: IValuesForm, 
    login: any, 
    client: TClientTokenCard 
): Promise<{
    block: T,
    isError: boolean
}> => {

    const expiration = values.cardValidity.split("/");
    const month = expiration[0];
    const year = expiration[1];
    const first4Numbers = values.cardNumber.slice(0, 4);
    const last4Numbers = values.cardNumber.slice( values.cardNumber.length - 4, values.cardNumber.length);
    let cardNumber: Array<string> | string = values.cardNumber.split(" ");
    
    cardNumber = cardNumber.join("");

    const { isError, block } = await postBlock("card/create", {
        holderName: values.nameOnCard,
        first4Digits: first4Numbers,
        last4Digits: last4Numbers,
        expirationYear: year,
        expirationMonth: month,
        cardbuyerId: client.id,
        security_code: values.cvv,
        card_number: cardNumber,
        branchsId: login.user.branchsId,
        sellerOwnerPayId: login.user.branchs.sellerOwnerPayId,
        apiOwnerId: login.user.powerUser === true ? "ZOOP" : login.user.branchs.apiOwner.description,
        buyerIdAdquirente: client.buyerIdAdquirente
    })

    return {
        block: block,
        isError: isError
    }
}